import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import './input.scss';
function URInput(props: any) {
  let { className, name, disabled, value, readonly, placeHolder, maxLength, onChange, ...restProps } = props;
  
  return (
    <div className="">
       <Input allowClear name={name} onChange={onChange} {...restProps} placeholder={placeHolder}
        className={className} value={value} maxLength={maxLength} />
    </div>
  );
}

export {
  URInput
};

URInput.defaultProps = {
  className: "",
  disabled: false
};

URInput.propTypes = {
  className: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.any,
  placeHolder: PropTypes.any,
  value: PropTypes.any,
  name: PropTypes.any,
  maxLength: PropTypes.any,
  readonly: PropTypes.string
};
